"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventHistoryTableItem = /** @class */ (function () {
    function EventHistoryTableItem() {
    }
    return EventHistoryTableItem;
}());
exports.default = EventHistoryTableItem;
